import { makeAutoObservable } from "mobx";

import {
  CreateSeerlinqStudyText,
  PatientMonitoringType,
  StudyTextMarkup,
  apiPostStudyText,
} from "../../../api";
import { StudyTexts, toStudyTextsItem } from "./study-texts";

export class AddStudyText {
  monitoring_type: PatientMonitoringType | null = null;
  study_text_language: string | null = null;
  study_text_markup = StudyTextMarkup.html;
  study_text_version = "1.0";
  study_text = "";
  country: string | null = null;
  region: number | null = null;
  clinic_uuid: string | null = null;
  physician_uuid: string | null = null;
  clinic_name = "";
  physician_name = "";

  constructor(private model: StudyTexts) {
    makeAutoObservable(this);
  }

  get canPost(): boolean {
    return (
      this.monitoring_type != null &&
      this.study_text_language != null &&
      this.study_text.trim().length > 0
    );
  }

  async post(): Promise<string> {
    if (this.monitoring_type == null || this.study_text_language == null) {
      throw new Error("Required fields missing");
    }
    const payload: CreateSeerlinqStudyText = {
      monitoring_type: this.monitoring_type,
      study_text_language: this.study_text_language,
      study_text_markup: this.study_text_markup,
      study_text_version: this.study_text_version,
      study_text: this.study_text,
      country: this.country,
      region: this.region,
      clinic_uuid: this.clinic_uuid,
      physician_uuid: this.physician_uuid,
    };
    const response = await apiPostStudyText({ body: payload });
    const newItem = toStudyTextsItem(response.data);
    this.model.data = [...this.model.data, newItem];

    return newItem.uuid;
  }
}
